import request from '@/utils/request'

export function getNews(data) {
    return request({
        url: 'admin/portal/home/getNews',
        method: 'post',
        data
    })
}

export function getInforms(data) {
    return request({
        url: 'admin/portal/home/getInforms',
        method: 'post',
        data
    })
}

export function getByNewsId(newsId) {
    return request({
        url: 'admin/portal/home/getByNewsId/'+newsId,
        method: 'post',
    })
}

export function getByinformId(informId) {
    return request({
        url: 'admin/portal/home/getByinformId/'+informId,
        method: 'post',
    })
}

// 实时危化品车辆总量统计
export function dataCentre693() {
    return request({
        url:process.env.VUE_APP_MHBASE + '/api/v1/dap/dataService/serviceApi/seal_DANGERGOODS_APPLY_graph_count/693',
        method: "get",
    });
}
